import React from "react";
import { ButtonWithLoader } from "@src/components/atoms/buttons/button-with-loader/button-with-loader";
import { TextButton } from "@src/components/atoms/buttons/text-button/text-button";
import { MachineAvailabilityStatus } from "@src/types/gateway-onboarding";
import { useAddNewMachineDrawerModalContext } from "./add-new-machine-drawer-modal-context";
import { MachineAvailabilityStatusPanel } from "./machine-availability-status/machine-availability-status";
import { VncSkillCard } from "./vnc-skill-card";
import { TwinSkillCard } from "./twin-skill-card";
import styles from "./add-new-machine-drawer-modal.module.scss";

export const AddNewMachineSkillsStep = () => {
  const {
    texts,
    hasTwinSkill,
    detectedMachineSkillTypes,
    machineAvailabilityStatus,
    machineAvailabilityError,
    machineOperationFailureDetails,
    showProtocolDetails,
    isInstallSkillsLoading,
    handleShowProtocol,
    handleGetSupport,
    handleInstallAndFinishSetup,
    handleFinishWithoutMachineSkills,
  } = useAddNewMachineDrawerModalContext();

  const description = detectedMachineSkillTypes
    ? texts.machineSkillsDescription.replace(
        "{skills}",
        detectedMachineSkillTypes,
      )
    : texts.noMachineSkillsFoundMessage;

  return (
    <>
      <p className={styles["skills-description"]}>{description}</p>
      <div className={styles["skills-list"]}>
        <VncSkillCard />
        {hasTwinSkill && <TwinSkillCard />}
      </div>

      {machineAvailabilityStatus === MachineAvailabilityStatus.FAILED && (
        <MachineAvailabilityStatusPanel
          status={machineAvailabilityStatus}
          errorMessage={machineAvailabilityError}
          failureDetails={machineOperationFailureDetails}
          showProtocolDetails={showProtocolDetails}
          onShowProtocol={handleShowProtocol}
          onGetSupport={handleGetSupport}
        />
      )}

      <div className={styles["button-row-step-two"]}>
        <ButtonWithLoader
          variant={["full-width"]}
          fun={handleInstallAndFinishSetup}
          text={texts.installAndFinishSetupButton}
          loading={isInstallSkillsLoading}
          disabled={isInstallSkillsLoading}
          spinnerVariant={["small"]}
        />
        <div
          className={styles["add-new-machine-drawer-modal__secondary-action"]}
        >
          <TextButton
            clickHandler={handleFinishWithoutMachineSkills}
            text={texts.finishSetupWithoutSkillsButton}
            variant="blue"
            disabled={isInstallSkillsLoading}
          />
        </div>
      </div>
    </>
  );
};
